import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    fallbackLng: "en",
    defaultNS: "common",
    ns: ["common", "workout", "profile", "settings", "account", "exerciseCreator", "privacyPolicy", "activityAnalysis"],
    debug: true,
    whitelist: ["en", "fr"],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      bindI18n: "languageChanged editorSaved",
    },
  });

export default i18n;
